export default "__VITE_ASSET__CU4hlOeu__"